import { FC } from 'react';

import ConfirmDeleteModal, {
  ConfirmDeleteModalProps,
} from '../confirm-delete-modal/ConfirmDeleteModal';

const ConfirmDeleteCustomerReminderModal: FC<
  Omit<ConfirmDeleteModalProps, 'entityName'>
> = (props) => (
  <ConfirmDeleteModal
    entityName={{ singular: 'customer reminder', plural: 'customer reminders' }}
    {...props}
  />
);

export default ConfirmDeleteCustomerReminderModal;
